module.exports = __webpack_public_path__ + "img/alice.i.914c16ae.png";